import StockBillMainContent from './components/StockBillMainContent'
import { inventoryTypeEnum } from './config'
import { useLocation } from 'react-router'
import { TypeContext } from './context/typs'
function StockOut() {
  const { state } = useLocation()
  return (
    <TypeContext.Provider value={{ type: inventoryTypeEnum.OUT, no: state && state.no, stockType: state && state.stockType }}>
      <StockBillMainContent />
    </TypeContext.Provider>
  )
}
export default StockOut
